import {
  CompetenciesCompetencyCrumbDocument,
  CompetencyJobRoleDeleteModalDocument,
  CompetencyRoleLevelsDataCollectionDocument,
  CompetencyRoleLevelsDataCollectionQuery,
  UnassingCompetencyLevelDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useLazyQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type JobCatalogTreeNode = NonNullable<
  CompetencyRoleLevelsDataCollectionQuery['jobCatalog']['treeNodes'][number]
>

const useUnassingCompetency = () => {
  const [deleteNodeAttribute] = useMutation(CompetencyJobRoleDeleteModalDocument, {
    extractorFn: (data) => data.jobCatalogMutations.deleteJobcatalogNodeAttribute,
    refetchQueries: [CompetencyRoleLevelsDataCollectionDocument],
  })

  const [getNodeAttribute] = useLazyQuery(UnassingCompetencyLevelDocument)

  const handleSubmit = async (
    node: Pick<JobCatalogTreeNode, 'id' | 'uuid'>,
    competencyId: number
  ) => {
    const { data } = await getNodeAttribute({ variables: { nodeUuid: node.uuid } })

    const nodeAttribute = data?.jobCatalog.nodeAttributesConnection.nodes?.find(
      ({ attributeId }) => attributeId === String(competencyId)
    )

    if (!nodeAttribute) return

    const response = await deleteNodeAttribute({
      variables: { id: nodeAttribute.id, treeNodeId: node.id },
      refetchQueries: [
        CompetencyRoleLevelsDataCollectionDocument,
        CompetenciesCompetencyCrumbDocument,
      ],
      awaitRefetchQueries: true,
    })

    const handled = handleResult(response, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })

      return handled
    }
  }

  return handleSubmit
}

export default useUnassingCompetency
